import React, { useCallback, useMemo, useReducer } from 'react';
import cn from 'classnames';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { IconButton } from 'ksnm-common-ui/lib/IconButton';
import { Modal } from 'ksnm-common-ui/lib/Modal';
import { Table } from 'ksnm-common-ui/lib/Table2/Table';
import { FILTER } from 'ksnm-common-ui/lib/Table2/utils/TableRequest/TableRequest.interface';
import type { Dispatch, ReactElement, SetStateAction } from 'react';

import { constantStore } from '@stores/constantStore';
import { dataControlStore } from '@stores/dataControlStore';
import { ksnmTableStore } from '@stores/ksnmTableStore/ksnmTableStore';

import { columns } from '../columns';

import styles from './LaunchesModal.module.scss';

interface ILaunchesModal {
  setSelectCtrlVers: Dispatch<SetStateAction<string | null>>;
  selectCtrlVers: string | null;
}

const { TABLE_NAMES } = constantStore;

export const LaunchesModal = ({ setSelectCtrlVers, selectCtrlVers }: ILaunchesModal): ReactElement | null => {
  const [isFullScreen, toggleIsFullScreen] = useReducer((fullSizeState) => !fullSizeState, false);
  const { lastPagesParam } = dataControlStore;

  const onClose = useCallback(() => setSelectCtrlVers(null), [setSelectCtrlVers]);

  const hardFilter = useMemo(
    () => [
      [
        ...(lastPagesParam.filters?.[0] ?? []),
        {
          name: 'ctrl_vers',
          type: FILTER.EQ,
          values: [selectCtrlVers],
          filterIsInverted: false,
        },
      ],
    ],
    [selectCtrlVers, lastPagesParam],
  );

  const extendTableButtons = useMemo(
    () => (
      <IconButton
        title={isFullScreen ? 'Уменьшить' : 'Увеличить'}
        onClick={toggleIsFullScreen}
        iconName={isFullScreen ? 'fullScreenOpen' : 'fullScreenClose'}
      />
    ),
    [isFullScreen],
  );

  if (!selectCtrlVers) return null;

  return (
    <Modal
      open={!!selectCtrlVers}
      className={cn(styles.modal, {
        [styles.fullScreen]: isFullScreen,
      })}
      centered
      footer={null}
      onCancel={onClose}
      width={isFullScreen ? '100vw' : '80vw'}
      closeIcon={<Icon name="close" noFill height={24} />}
    >
      <div className={styles.container}>
        <Table
          columns={columns}
          tableTitle={`Запуски по ${selectCtrlVers}`}
          tableName={TABLE_NAMES.LAUNCHES_MODAL}
          resource="v_ctrl_pckg"
          externalFetch={ksnmTableStore.externalFetch}
          externalFetchXLSX={ksnmTableStore.getExcelStreamV2}
          extendTableButtons={extendTableButtons}
          hardFilter={hardFilter}
          showAggregateRow={false}
          cellHeight={44}
        />
      </div>
    </Modal>
  );
};
